// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { HandlersMeResponse } from '../types';
import { createQueryKey } from '../utils/keys';

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getMeQueryKey = () =>
  createQueryKey<HandlersMeResponse>()(['me'] as const);
